import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteLangQual = () => {
    const [langQualifications, setLangQualifications] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedLangQualifications();
    }, []);

    const fetchDeletedLangQualifications = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/langQualifications/deleted');
            const data = await response.json();
            setLangQualifications(data);
        } catch (error) {
            console.error('Error fetching deleted Language Qualifications:', error);
        }
    };

    const handleRestore = async (langQualificationsId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this language qualification?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/langQualifications/restore/${langQualificationsId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        setLangQualifications(langQualifications.filter(langQualifications => langQualifications.id !== langQualificationsId));
                        Swal.fire({
                            title: "Restored!",
                            text: "The language qualification has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore Language Qualification');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the language qualification.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring Language Qualification:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the language qualification.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (langQualificationsId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the language qualification. This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/langQualifications/delete/permanent/${langQualificationsId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        setLangQualifications(langQualifications.filter(langQualifications => langQualifications.id !== langQualificationsId));
                        Swal.fire({
                            title: "Deleted!",
                            text: "The language qualification has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete Language Qualification permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the language qualification.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting Language Qualification permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the language qualification.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter language qualifications based on search term
    const filteredLangQuals = langQualifications.filter(qual =>
        (qual.langQualName && qual.langQualName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.university && qual.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.teachingMethod && qual.teachingMethod.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.duration && qual.duration.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.courseFee && qual.courseFee.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.payMethod && qual.payMethod.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.institutePhone && qual.institutePhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.instituteEmail && qual.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (qual.instituteWebsite && qual.instituteWebsite.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>

                <div className="search-icon-admin admin-course-search">

                    <h1>DELETE LANGUAGE QUALIFICATIONS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                   
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                    <th>Language Exam Name</th>
                                    <th>Institute Name</th>
                                    <th>Teaching Method</th>
                                    <th>Duration</th>
                                    <th>Course Fee</th>
                                    <th>Paying Method</th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredLangQuals.map((langQualifications) => (
                                    <tr key={langQualifications.id}>
                                        <td>{langQualifications.langQualName}</td>
                                        <td>{langQualifications.university}</td>              
                                        <td>{langQualifications.teachingMethod}</td>
                                        <td>{langQualifications.duration}</td>
                                        <td>{langQualifications.courseFee}</td>              
                                        <td>{langQualifications.payMethod}</td>
                                        <td>{langQualifications.institutePhone}</td>
                                        <td>{langQualifications.instituteEmail}</td>
                                        <td>
                                            <a href={langQualifications.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                                Visit Website
                                            </a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(langQualifications.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(langQualifications.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteLangQual